export default class ODataUtils {
    static encryptQueryContent(content) {
        content = content.replace(/'/g, "''");
        content = content.replace(/%/g, "%25");
        content = content.replace(/\+/g, "%2B");
        content = content.replace(/\//g, "%2F");
        content = content.replace(/\?/g, "%3F");
        content = content.replace(/#/g, "%23");
        content = content.replace(/&/g, "%26");
        return content;
    }
}
